// hide site preloader after a minimum display time from page start,
// long enough for the logo draw + square pop intro to play through once;
// resolves window.__preloaderHidden so animations can wait for it
window.__preloaderHidden = new Promise(function (resolve) {
  var el = document.getElementById('site-preloader');
  if (!el) { resolve(); return; }
  var elapsed = Date.now() - (window.__preloaderStart || 0);
  var delay = Math.max(0, 2300 - elapsed);
  function hide() {
    el.classList.add('site-preloader--hidden');
    el.addEventListener('transitionend', function () { el.remove(); resolve(); }, { once: true });
    setTimeout(function () { if (el.parentNode) el.remove(); resolve(); }, 600);
  }
  delay > 0 ? setTimeout(hide, delay) : hide();
});

// JS
import 'jquery';
import 'popper.js';
import 'bootstrap';

// css/scss
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

// custom JS
import './custom';

import '../scss/styles.scss';
import '../scss/custom.scss';

import '../scss/navbar.scss';
import '../scss/footer.scss';
import '../scss/width.scss';

import '../css/delimiters.css';
import '../css/gradients.css';
import '../css/backgrounds.css';
import '../scss/dots-animation.scss';
